<template>
  <section class="table-data-filter" :style="{ width: width }">
    <div class="header-select" ref="refrence" @click.stop="showSelect">
      <span
        >{{ title }}
        <span v-if="choosed.length > 0">({{ choosed.length }})</span>
        <i class="el-icon el-icon-caret-bottom"></i>
      </span>
    </div>
    <transition name="height-fade">
      <div
        class="table-data-filter-search-container"
        ref="popper"
        v-show="isShow"
        @click.stop
        :style="{
          height: height + 'px',
          width: filterContentWidth,
        }"
      >
        <div v-if="showFilterDesc" class="filter-desc">
          {{ showFilterDesc }}
        </div>
        <div class="check-all" v-else>
          <el-checkbox
            class="all"
            v-model="checkAll"
            :indeterminate="isIndeterminate"
            :disabled="!hasFilterOptions"
            >{{ allString }}</el-checkbox
          >
        </div>
        <i class="line"></i>
        <div class="center-container">
          <div class="search">
            <input
              type="text"
              v-if="items.length > 8"
              @click.stop
              ref="search"
              v-model="search"
              placeholder="请输入搜索内容"
              maxlength="20"
            />
            <i
              v-if="search"
              @click="search = ''"
              class="el-icon el-icon-circle-close"
            ></i>
          </div>
          <el-checkbox-group
            :style="{ top: items.length > 8 ? '40px' : '0' }"
            class="checkbox-group"
            v-model="selfChosen"
          >
            <div v-if="!hasFilterOptions" class="empty-filter-options">暂无筛选项</div>
            <DynamicScroller
              v-else
              :items="listItem"
              :min-item-size="40"
              :key-field="itemKeyCode"
              class="scroller"
            >
              <template v-slot="{ item, index, active }">
                <DynamicScrollerItem
                  :item="item"
                  :active="active"
                  :size-dependencies="[item[itemKeyName]]"
                  class="item"
                  :data-index="index"
                >
                  <el-checkbox class="checkbox" :label="item[itemKeyCode]">
                    <p v-textPopper>
                      {{
                        !isObject(item[itemKeyName]) ? item[itemKeyName] : ""
                      }}
                    </p>
                    <slot
                      :row="item[itemKeyName]"
                      v-if="isObject(item[itemKeyName])"
                    ></slot>
                  </el-checkbox>
                  <span
                    class="arrow arrow-animate"
                    :key="item[itemKeyCode]"
                    @click.stop="showThisOne(item)"
                  >
                    <img
                      src="~@/assets/images/a20.png"
                      alt=""
                      v-for="i in 3"
                      :key="i"
                    />
                  </span>
                </DynamicScrollerItem>
              </template>
            </DynamicScroller>
          </el-checkbox-group>
        </div>
        <div class="btn-wrapper">
          <i class="line"></i>
          <button class="btn confirm" @click="confirm">确认</button>
        </div>
      </div>
    </transition>
  </section>
</template>

<script>
import pinyinMatch from "pinyin-match";
import Popper from "popper.js";
import { DynamicScroller, DynamicScrollerItem } from "vue-virtual-scroller";
import "vue-virtual-scroller/dist/vue-virtual-scroller.css";
import event from "@/utils/event";

export default {
  data() {
    return {
      isShow: false,
      isShowSearch: false,
      // checkAll: false,
      disableCheckAll: false,
      isIndeterminate: false,
      search: "",
    listItem: JSON.parse(JSON.stringify(this.items)),
      selfChosen: [],
      autoConfirming: false,
    };
  },

  props: {
    title: String, // 表头默认文字
    allString: {
      // 选择所有默认文字
      default: "选择所有",
      type: String,
    },
    showFilterDesc: {
      // 展示表头描述文字
      default: "",
      type: String,
    },
    itemKeyName: {
      // 多选框后面的名字
      default: "name",
      type: String,
    },
    itemKeyCode: {
      // 根据这个字段得到筛选后的id数组
      default: "id",
      type: String,
    },
    items: {
      // 外部传入需要筛选的列表
      default: () => [],
      type: Array,
    },
    value: {
      // 用于 v-model绑定值
      default: () => [],
      type: Array,
    },
    height: {
      default: 380,
      type: Number,
    },
    searchKey: [Array, String],
    width: {
      type: String,
      default: "100%",
    },
    filterContentWidth: {
      type: String,
      default: "240px",
    },
    autoConfirmOnChange: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    choosed: {
      get() {
        return this.value;
      },

      set(value) {
        this.$emit("input", value);
      },
    },

    isObject() {
      return function (o) {
        return typeof o === "object";
      };
    },
    checkAll: {
      get() {
        return this.listItem.length > 0 && this.selfChosen.length == this.listItem.length;
      },
      set(value) {
        if (value) {
          this.selfChosen = this.listItem.map(
            (value) => value[this.itemKeyCode]
          );
        } else {
          this.selfChosen = [];
        }
      },
    },
    hasFilterOptions() {
      return this.listItem.length > 0;
    },
  },

  watch: {
    items(newVal) {
      this.listItem = JSON.parse(JSON.stringify(newVal));
    },

    search(newVal) {
      if (newVal.length > 0) {
        this.checkAll = false;
      } else {
        this.checkAll = false;
      }

      this.listItem = this.items.filter((value) => {
        if (this.isObject(value[this.itemKeyName]) && this.searchKey) {
          const arr =
            typeof this.searchKey === "string"
              ? [this.searchKey]
              : this.searchKey;
          let str = arr.reduce((next, prev) => {
            next += value[this.itemKeyName][prev];
            return next;
          }, "");
          let matchResult = pinyinMatch.match(str, newVal);
          if (matchResult || str.indexOf(newVal) !== -1) {
            return value;
          }
        } else {
          let matchResult = pinyinMatch.match(value[this.itemKeyName], newVal);
          if (matchResult || value[this.itemKeyName].indexOf(newVal) !== -1) {
            return value;
          }
        }
      });
    },

    selfChosen(newVal) {
      if (newVal.length === 0) {
        this.isIndeterminate = false;
      } else if (
        this.listItem.every((value) => newVal.includes(value[this.itemKeyCode]))
      ) {
        this.isIndeterminate = false;
      } else {
        this.isIndeterminate = true;
      }
      if (
        this.autoConfirmOnChange &&
        this.isShow &&
        !this.autoConfirming &&
        JSON.stringify(newVal) !== JSON.stringify(this.choosed)
      ) {
        this.autoConfirming = true;
        this.$nextTick(() => {
          this.confirm();
          this.autoConfirming = false;
        });
      }
    },
  },

  created() {
    window.document.addEventListener("click", this.close);
    this.symbol = Symbol("tableDataFilterSymbol"); // 用于关闭非自身表头筛选
    event.$on("TABLE_DATA_FILTER_CLICK", this.listenOtherTableFilterClick);
  },

  mounted() {
    document.body.appendChild(this.$refs.popper);
    this.popper = new Popper(
      {
        getBoundingClientRect: () =>
          this.$refs.refrence.getBoundingClientRect(),
        clientWidth: this.$refs.refrence.clientWidth,
        clientHeight: this.$refs.refrence.clientHeight,
      },
      this.$refs.popper,
      {
        placement: "bottom-start",
        modifiers: {
          offset: {
            offset: "0, 10px, 0, 0",
          },
        },
      }
    );
  },

  beforeDestroy() {
    document.removeEventListener("click", this.close);
    event.$off("TABLE_DATA_FILTER_CLICK", this.listenOtherTableFilterClick);
    if (document.body.contains(this.$refs.popper)) {
      document.body.removeChild(this.$refs.popper);
    }
    clearInterval(this.timer);
  },

  methods: {
    showSelect() {
      document.getElementById("app").click();
      if (this.isShow) {
        this.isShow = false;
        return;
      }
      this.isShow = true;
      this.selfChosen = [...this.choosed];
      event.$emit("TABLE_DATA_FILTER_CLICK", this.symbol);
      this.popper.update();
      let headerRect = this.$refs.refrence.getBoundingClientRect();
      this.timer = setInterval(() => {
        try {
          let nowPositon = this.$refs.refrence.getBoundingClientRect();
          if (
            headerRect.top !== nowPositon.top ||
            headerRect.left - nowPositon.left < -20
          ) {
            this.close();
          }
        } catch (e) {
          clearInterval(this.timer);
        }
      }, 100);
    },

    listenOtherTableFilterClick(symbol) {
      if (symbol !== this.symbol) {
        this.close();
      }
    },

    showThisOne(item) {
      this.choosed = [item[this.itemKeyCode]];
      this.close();
      this.$nextTick(() => {
        this.$emit("confirm", [...this.choosed]);
      });
    },

    close() {
      this.isShow = false;
      // this.search = ''
      clearInterval(this.timer);
    },

    confirm() {
      this.choosed = [...this.selfChosen];
      this.close();
      this.$nextTick(() => {
        this.$emit("confirm", [...this.choosed]);
      });
    },
  },

  components: {
    DynamicScroller,
    DynamicScrollerItem,
  },
};
</script>

<style lang="scss">
.table-data-filter {
  position: relative;
  display: inline-grid;
  padding: 0;
  margin: 0;
  width: 100%;

  div {
    padding: 0;
  }

  .header-select {
    position: relative;
    height: 28px;
    line-height: 28px;
    width: 100%;
    background: #fff;
    font-size: 14px;
    padding: 0 10px;
    color: #333;
    white-space: nowrap;

    i {
      float: right;
      line-height: 28px;
    }
  }
}

.height-fade-enter-active {
  transition: height 0.3s ease, opacity 0.3s ease;
}

.height-fade-leave-active {
  transition: height 0.3s ease, opacity 0.3s ease;
}

.height-fade-enter,
.height-fade-leave-to
/* .slide-fade-leave-active for below version 2.1.8 */ {
  height: 100px !important;
  opacity: 0;
}

.table-data-filter-search-container {
  position: fixed;
  top: 50px;
  display: block;
  width: 240px;
  height: 380px;
  padding: 0 !important;
  background: #fff;
  z-index: 9999;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.15);

  .filter-desc {
    height: 40px;
    display: flex;
    align-items: center;
    padding-left: 10px;
    font-size: 14px;
    color: #333;
    font-weight: bold;
  }

  .check-all {
    display: flex;
    align-items: center;
    padding: 0 10px;
    height: 40px;
    text-align: left;

    ::v-deep .el-checkbox {
      .el-checkbox__label {
        font-weight: bold;
        color: #333;
      }
    }
    .all {
      ::v-deep .el-checkbox__input.is-checked {
        .el-checkbox__inner {
          background: #009688;

          &::after {
            border: 2px solid #fff !important;
            border-left: 0 !important;
            border-top: 0 !important;
          }
        }
      }

      ::v-deep .is-indeterminate .el-checkbox__inner {
        background: #009688;
      }

      ::v-deep .is-indeterminate .el-checkbox__inner::before {
        background-color: #fff;
      }
    }
  }

  .line {
    display: block;
    height: 1px;
    background: #ebebeb;
  }

  .center-container {
    position: absolute;
    top: 40px;
    bottom: 50px;
    left: 0;
    right: 0;
    // overflow-y: auto;

    .search {
      position: relative;
      display: block;
      margin-top: 6px;

      input {
        display: block;
        margin: 0 auto;
        padding: 0 30px 0 10px;
        width: 96%;
        height: 30px;
        border: 1px solid #999;
        border-radius: 3px;
        font-size: 14px;
        color: #999;
      }

      i {
        position: absolute;
        top: 50%;
        right: 10px;
        transform: translateY(-50%);
        cursor: pointer;
      }
    }

    .checkbox-group {
      display: block;
      // overflow-y: scroll;
      position: absolute;
      top: 40px;
      bottom: 0;
      width: 100%;

      .scroller {
        height: 100%;
        padding: 10px;
      }

      .empty-filter-options {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 100%;
        color: #999;
        font-size: 13px;
      }

      .checkbox {
        display: flex;
        align-items: center;
        box-sizing: border-box;
        flex: 1;
        // margin-right: 4px;
      }

      .item {
        display: flex;
        align-items: center;
        height: 40px;
        width: 100%;
        padding-left: 10px;

        .el-checkbox__label {
          max-width: 230px;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }

        &:hover {
          background: #f7f7f7;
          .arrow {
            visibility: visible;
          }
        }
      }
    }

    ::v-deep .el-checkbox {
      display: inline-block;
      width: 170px;
      margin: 8px 0 8px 10px;
      line-height: 24px;

      > span {
        display: inline-block;
        vertical-align: top;
        // white-space: pre-line;
      }

      .el-checkbox__label {
        text-align: left;
        width: 160px;
        color: #333;
        line-height: 27px;
      }
    }

    ::v-deep .el-checkbox-group {
      ::v-deep .is-checked .el-checkbox__inner {
        background: #fff !important;
      }

      ::v-deep .is-checked .el-checkbox__inner::after {
        border-color: #009688 !important;
      }
    }

    .arrow {
      // display: inline-block;
      visibility: hidden;
      margin-left: 6px;
      margin-right: 6px;
      cursor: pointer;

      img {
        display: inline-block;
        width: 8px;
      }
    }

    .arrow-animate {
      flex-shrink: 0;
      @for $i from 1 through 3 {
        img:nth-of-type(#{$i}) {
          animation: twinkle#{$i} 1s infinite;
          animation-delay: 0.2s * $i;
        }

        @keyframes twinkle#{$i} {
          0% {
            opacity: 0;
          }

          50% {
            opacity: 1;
          }

          100% {
            opacity: 0;
          }
        }
      }
    }
  }

  .btn-wrapper {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 0;
    height: 50px;
    text-align: center;
  }

  .confirm {
    display: inline-block;
    margin-top: 10px;
    width: 180px;
    height: 30px;
    background: #009688;
    border-radius: 3px;
    color: #fff;
    font-size: 14px;
  }
}
</style>
